<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
    <!-- メインコンテンツ -->
    <div class="main-content" [class.platform-large-text]="getTextSize()">
        <!-- タイトル -->
        <div class="title">
            <h1>連携事例登録・管理</h1>
        </div>

        <!-- ボタンエリア -->
        <div class="p-d-flex insert-task-button-area">
            <div class="task-button-area">
                <button pButton type="button" label="連携事例を登録する" class="my-task-button1" (click)="moveH101()"></button>
            </div>
        </div>

        <!-- 検索条件入力 -->
        <div class="p-d-flex search-form-area" [formGroup]="h104SearchForm">
            <!-- ステータス -->
            <div class="p-d-flex status-area">
                <div class="p-as-center item-label">ステータス</div>
                <p-dropdown [options]="statusList" optionLabel="sp_name" optionValue="sp_code"
                    placeholder="選択してください" [showClear]="true" styleClass="status-Form-dropdown" formControlName="status"
                    class="p-as-center"></p-dropdown>
            </div>

            <!-- 検索ボタン -->
            <div class="p-d-flex search-button-area">
                <div class="p-as-center search-button">
                    <button pButton type="button" label="検索" class="search-button-size button1"
                        (click)="getResultDataList(true)"></button>
                    <button pButton type="button" label="検索条件をクリアする" class="clear-button button2"
                        (click)="clearConditions()"></button>
                </div>
            </div>
        </div>

        <!-- 結果表示 -->
        <div class="result-area">
            <!-- 検索結果数 -->
            <div class="result-count-area">
                <label class="count"> {{ resultDataList.length }} </label>
                件
            </div>
            <!-- リスト表示 -->
            <p-table #table [value]="resultDataList" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
                [rowsPerPageOptions]="[10, 50, 100, 500, 1000]" emptyMessage="データが存在しません" selectionMode="single"
                styleClass="list-area">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="No" pSortableColumn="cooperation_id">No<p-sortIcon field="cooperation_id"></p-sortIcon>
                        </th>
                        <th class="title" pSortableColumn="title">タイトル<p-sortIcon field="title"></p-sortIcon>
                        </th>
                        <th class="status" pSortableColumn="status">ステータス<p-sortIcon field="status"></p-sortIcon>
                        </th>
                        <th class="update_datetime" pSortableColumn="update_datetime">更新日時<p-sortIcon
                                field="update_datetime"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-resultDataList>
                    <tr class="list" >
                        <!-- No -->
                        <td class="No">
                          <a [attr.href]="'pages/platform/h301/' + resultDataList.cooperation_id" target="_blank">
                            {{ resultDataList?.cooperation_id }}
                          </a>
                        </td>
                        <!-- タイトル -->
                        <td class="title"  [class.task-data]="resultDataList.title">
                          <a [attr.href]="'pages/platform/h301/' + resultDataList.cooperation_id" target="_blank">
                            {{ resultDataList?.title }}
                          </a>
                        </td>
                        <!-- ステータス -->
                        <td>
                          <a [attr.href]="'pages/platform/h301/' + resultDataList.cooperation_id" target="_blank">
                            <p *ngIf="0 == resultDataList.status">
                                一時保存
                            </p>
                            <p *ngIf="1 == resultDataList.status">
                                未承認
                            </p>
                            <p *ngIf="2 == resultDataList.status">
                                承認
                            </p>
                            <p *ngIf="3 == resultDataList.status">
                                非承認
                            </p>
                            <p *ngIf="4 == resultDataList.status">
                                要修正
                            </p>
                          </a>
                        </td>
                        <!-- 更新日時 -->
                        <td class="update-datetime">
                          <a [attr.href]="'pages/platform/h301/' + resultDataList.cooperation_id" target="_blank">
                            {{ resultDataList?.update_datetime }}
                          </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>


        </div>
    </div>

<!-- フッダー -->
<footer>
    <app-footer></app-footer>
  </footer>
